import { render, staticRenderFns } from "./Detailtable.vue?vue&type=template&id=917ec07e"
import script from "./Detailtable.vue?vue&type=script&lang=js"
export * from "./Detailtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports